import script from "./AtomButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomButton.vue?vue&type=script&lang=ts&setup=true"

import "./AtomButton.vue?vue&type=style&index=0&id=24a282d7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a282d7"]])

export default __exports__